import React from "react";
import { html } from "lit";
import { NoDataComponent, MediaOpsService, AlertMessagesService, OmniIconComponent, OmniSearchComponent, OmniStyleComponent, OmniTableStickyComponent, OmniToolbarComponent, Utils } from "../../../../shared";
import  PlatformFilterComponent  from "./platformFilterComponent";
import { querySelectorDeep, sortNumber, sortObjects } from "omni-ui";
import PlatformCampaignDialogComponent from "./platformCampaignDialogComponent";
import { CampaignFilterComponent } from "../../";

export default class MapInPlatformCampaignsComponent extends React.Component {

    defaultState = {
        isModelOpen: false,
        platformData: [],
        platformTableData: [],
        campaignTableData: [],
        enableMapToPlacement: true,
        saveBtnToastMessageData: [],
        filterDropdownOptions: {
            channel: [],
            campaign: [],
        },
        isPlatformTableLoading: false,
        isCampaignTableDataLoading: false,
        sort: {platformSort:{ key: '', dir: '' }, campaignSort:{ key: '', dir: '' }},
    };

    componentIsMounted = true;
    modelMappingData = [];
    modelDropdownOptions = [];

    constructor(props) {
        super(props);
        this.state = this.defaultState;
    }

    /**
     * Load more table data
     * @param {number} index
     * @returns {void}
     */
    componentDidMount() {
        if(this.componentIsMounted){
            this.componentIsMounted = false;
            this.fetchPlatformDeliveredData();
            this.props.setSpinnerCount(0)
            this.fetchCampaignTableData(null, this.props.loadedCampaignData);
            this.setState({ filterDropdownOptions: {...this.state.filterDropdownOptions} });
        }
    };

    /**
     * Update the sort column for the table data 
     * @param {Object} event
     */
    updateSortColumn = (event, type) => {  
        const tableDataName = type === 'platform' ? 'platformTableData' : 'campaignTableData';
        const sortName = type === 'platform' ? 'platformSort' : 'campaignSort'; 
        let sortedData = [...this.state[tableDataName]]
            Object.assign(this.state.sort[sortName], event.detail.sort);
            if (event.detail.sort?.dir === 'asc') {
                sortedData = sortObjects(this.state[tableDataName], event.detail.sort?.key, (a, b) => sortNumber(a[event.detail.sort.key], b[event.detail.sort.key]));
            } else if (event.detail.sort?.dir === 'desc') {
                sortedData = this.state[tableDataName].reverse();
            }
            this.setState({ [tableDataName]: sortedData });
    }

    /**
     * Handle the unmapping of the platform campaign data to the campaign
     * @param {number} placement_id
     * @returns {void}
     */
    handleUnmapped = (value) => {
        this.props.setSpinnerCount(1);
        const selectedCount = 1;
        const payload = {
            id: [value.id],
            map: 'false'
        };

        MediaOpsService.mapPlatformCampaign(payload)
        .then((response) => {
            this.props.setSpinnerCount(0);
            this.fetchCampaignTableData();
            this.fetchPlatformDeliveredData();
            this.setState(this.defaultState);
            AlertMessagesService.showSuccessToastMessage(`You have unmapped ${selectedCount} platform campaigns!`);
        }).catch((error) => {
            AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: this.mapToCampaign, title: `Unable to unmap ${selectedCount} platform campaigns!`, bodyMsgArr: []}]);
            this.props.setSpinnerCount(0);
        });
    }

    /**
     * Fetch the platform campaign data from the API
     * @param {string} options
     * @param {string} type
     * @returns {void}
     */
    fetchPlatformDeliveredData = (options, type) => {
        this.modelMappingData = [];
        this.setState({ platformTableData: [], isPlatformTableLoading: false});
        this.setState({ isPlatformTableLoading: true });
            if (options) {
                let data = this.state.platformData;
                if (type === 'search' && Object.keys(options).length) {
                    data = data?.filter((item) => item.taxonomy_value.toLowerCase().includes(options.search.trim().toLowerCase()));
                } else if (type === 'filter' && Object.keys(options).length) {
                    data = data?.filter((item) => item.taxonomy_value.toLowerCase().includes(options.objectName.trim().toLowerCase()));
                }
                this.createPlatformNestedData(data);
            } else {
                MediaOpsService.getPlatformCampaign()
                .then((response) => {
                    this.setState({ platformData: response?.data || [] });
                    this.createPlatformNestedData(response?.data);
                }).catch((error) => {
                    AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Refresh', retryBtnEvent: () => this.fetchPlatformDeliveredData(options, type), title: 'Platform API cannot be loaded', bodyMsgArr: []}]);
                    this.setState({ isPlatformTableLoading: false });
                });
            }
    }

    /**
     * Create the platform nested data from the API response data
     * @param {array} data
     * @param {string} type
     * @returns {void}
     */
    createPlatformNestedData = (data) => {
        this.setState({ platformTableData: data, isPlatformTableLoading: false});
    };

    /**
     * Fetch the placement table data from the API
     * @param {string} options
     * @returns {void}
     */
    fetchCampaignTableData = (options, data) => {
        this.setState({ isCampaignTableDataLoading: true });
        if(data && data.length){
            this.createNestedData(data);
            this.modelDropdownOptions = data.map(item => ({value:item.campaignName, id:item.id, synthetic_id: item.synthetic_id, channels:item.partners}))
        }else{
            MediaOpsService.getCampaignData(options ? options : {source: 'planned', 'page-count': 10},this.state.hasNext, this.state.archiveTab, this.props?.versionOneApi).then(response => {
                this.setState({ isCampaignTableDataLoading: false });
                if(response?.data?.Items?.length){
                    let data = MediaOpsService.prepareCampaignData(response?.data?.Items);
                    this.createNestedData(data);
                    this.modelDropdownOptions = data.map(item => ({value:item.campaignName, id:item.id, synthetic_id: item.synthetic_id, channels:item.partners}))
                }else{
                    this.setState({ campaignTableData: [] });
                }
            }).catch(() => {
                AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Refresh', retryBtnEvent: () => this.fetchCampaignTableData(options, data), title: 'Campaign API cannot be loaded', bodyMsgArr: []}]);
                this.setState({ isCampaignTableDataLoading: false });
            });
        }
    }

    /**
     * Create the placement nested data from the API response data
     * @param {array} loadedCampaignData
     * @returns {void}
     */
    createNestedData = (campaigns, isFreshData) => {
        const { transformedFilterData } = MediaOpsService.createCampaignNestedData(campaigns, true);
        const createMappedData  = (data, type='parent') => data.map((item) => {
            const nestedData = item.nestedData || [];
            if (item.delivered_campaigns?.length) {
                const deliveredCampaigns = item.delivered_campaigns.map((campaign) => ({...campaign, marginClass: `margin-left-${type === 'parent' ? '20' : '40'}`}));
                item.nestedData = [...deliveredCampaigns, ...nestedData];
            }
            if (nestedData?.length) {
                item.nestedData = createMappedData(item.nestedData, 'child');
            }
            return item;
        })
        this.setState({ campaignTableData: createMappedData(transformedFilterData),  isCampaignTableDataLoading: false}, () => {
            setTimeout(() => {
                this.props.setSpinnerCount(0);
                if(isFreshData && this.state.hasNext){
                    this.loadMoreTableData(0);
                }
            });
        });
    }

    /**
     * Fetch the platform campaign data from the API based on the search parameter
     * @param {Object} event
     * @param {string} type
     * @returns {void}
     */
    updateSearch = (event, type) => {
        const searchParam = event.detail.value;
        if(type === 'campaign'){
            this.setState({ isCampaignTableDataLoading: true });
            const queryParam = { 'campaign-name': searchParam }
            MediaOpsService.searchCampaign(queryParam, false).then(response => {
                this.setState({ isCampaignTableDataLoading: false });
                let data = MediaOpsService.prepareCampaignData(response?.data?.Items);
                this.createNestedData(data);
            }).catch(() => { 
                this.setState({ isCampaignTableDataLoading: false });
            });
        }else{
            const search = searchParam.trim().length ? {search:searchParam} : {};
            this.fetchPlatformDeliveredData(search, 'search');
        }
    }

    /**
     * Apply the filter based on the type and options provided
     * @param {string} type
     * @param {Object} options
     * @returns {void}
     */
    applyFilter = (type, options) => {
        if(type === 'campaing'){
            this.fetchCampaignTableData(options);
        }else{
            this.fetchPlatformDeliveredData(options, 'filter');
        }
    }

    /**
     * Close the model and add the message to the state based on the value provided
     * @param {array} value
     */
    closeModel = (value) => {
        if (value && value.length) {
            this.setState({ saveBtnToastMessageData: [...this.state.saveBtnToastMessageData, 'mapped'] });
        }
        this.setState({ isModelOpen: false });
    };

    /**
     * Handle the save button click event and navigate to the previous page and show the success toast message
     * @returns {void}
     */
    handleSaveButton = () => {
        if(this.state.saveBtnToastMessageData.length){
            let message = '';
            if(this.state.saveBtnToastMessageData.every(val => val === 'mapped')){
                message = 'mapped'
            }else if(this.state.saveBtnToastMessageData.every(val => val === 'unmapped')){
                message = 'unmapped'
            }else if (this.state.saveBtnToastMessageData.some(val => val === 'mapped') && this.state.saveBtnToastMessageData.some(val => val === 'unmapped')) {
                message = 'mapped and unmapped'
            }
            AlertMessagesService.showSuccessToastMessage(`You have successfully ${message} Platform campaigns!`);
        }
        this.props.navigate('/')
    };

    /**
     * Select all the objects in the table and update the state based on the checked value and the nested data
     * @param {Object} event
     * @returns {void}
     */
    selectAllObjects = (event) => {
        const checked = event.target.checked;
        const checkedData = (data) => data.map((item) => {
            if (item.nestedData) {
                item.nestedData = checkedData(item.nestedData);
            } else {
                item.checked = checked;
                if (checked) { 
                    if (!this.modelMappingData.some(one => one === item.id)){
                        this.modelMappingData.push(item.id);
                    }
                }  else {
                    this.modelMappingData = [];
                }
            }
            
            return item;
        })
        this.setState({ platformTableData: checkedData(this.state.platformTableData), enableMapToPlacement: !checked });
    };

    /**
     * Select the object in the table and update the state based on the checked value and
     * the nested data and the id of the object selected or unselected
     * @param {Object} event
     * @param {number} id
     * @returns {void}
     */
    selectObject = (event, value) => {
        const nestedData = []
        const checked = event.target.checked;
        const checkedData = (data) => data.map((item) => {
            if (item.nestedData) {
                item.nestedData = checkedData(item.nestedData);
            }else{
                if (item.id && (item.id === value.id)) {
                    if (checked){
                        if (!this.modelMappingData.some(one => one === item.id)){                      
                            this.modelMappingData.push(item.id);
                        }
                    }else{
                        this.modelMappingData = this.modelMappingData.filter(one => one !== item.id);
                    }
                    item.checked = checked;
                }
                nestedData.push(item);
            }
            return item;
        })
        const orphanedData = checkedData(this.state.platformTableData);
        const enableMapToPlacement = !nestedData.some((one) => one.checked);
        const checkboxEl = /** @type {HTMLInputElement} */ (querySelectorDeep('omni-table-sticky', 'platform-campaign-table').shadowRoot.querySelector('.scroll-table').shadowRoot.getElementById("platform-table-selectall"));
        checkboxEl.checked = nestedData.every((one) => one.checked);
        this.setState({ platformTableData: orphanedData, enableMapToPlacement });
    }

    /**
     * Handle the single map event and open the model to map the platform campaign data
     * to the placement based on the value provided and update the state based on the value provided
     * @param {Object} value
     * @returns {void}
     */
    handleSingleMap = (value) => {
        this.selectAllObjects({target: {checked: false}});
        const checkboxEl = /** @type {HTMLInputElement} */ (querySelectorDeep('omni-table-sticky', 'platform-campaign-table').shadowRoot.querySelector('.scroll-table').shadowRoot.getElementById("platform-table-selectall"));
        checkboxEl.checked = false;
        this.modelMappingData = [value.id];
        this.setState({isModelOpen: true })
    }

    /**
     * Handle the multiple mapping event and open the model to map the
     * platform campaign data to the placement based on the value provided
     */
    handleMultipleMapping = () => {
        this.setState({isModelOpen: true })
    }

    platformLeftColumns = [
        {
            key: "",
            passthrough: true,
            isMain: true,
            label: html`
            <style>
            :host::part(table-header-select) {
                text-align: end;
                padding-right: 0.6rem;
            }
            </style>
            <omni-checkbox part="select-platform-checkbox" id="platform-table-selectall" @change=${this.selectAllObjects}/>`,
            template: (value, index) => { return !value.nestedData ? html`<td part="table-body-cell"><omni-checkbox part="select-platform-checkbox" id="platform-select" @change=${(event) => this.selectObject(event, value)} ?checked=${value.checked}/> </td>` : '' }
        },
        {
            label: 'OBJECT NAME',
            key: 'taxonomy_value',
            isSortable: true,
            passthrough: true,
            template: (value, index) => {
                return html`
                <style>
                :host::part(parent-name-cell) {
                    color: var(--core-color-core-dark-100, #3B3E3F);
                }
                </style>
                <td part="table-body-cell parent-name-cell">${value.taxonomy_value}</td>`
            }
        },
    ];

    platformRightColumns = [
        {
            label: 'Actions',
            key: 'actions',
            passthrough: true,
            template: (value, index) => {
                return !value.nestedData ? html`
                <style>
                :host::part(table-body) {
                    transform-style: flat;
                }
                </style>
                <td part="table-body-cell"><button part="mapButton" class="button is-outlined" @click=${() => this.handleSingleMap(value)}>Map</button></td>`
                : html`<td part="table-body-cell"/>`
            }
        }
    ];

    campaignLeftColumns = [
        {
            key: "",
            passthrough: true,
            isMain: true,
            template: () => ""
        },
        {
            label: 'CAMPAIGN NAME',
            key: 'campaignName',
            isSortable: true,
            passthrough: true,
            template: (value, index) => {
                const campaignName = value.campaignName ? value.campaignName : value.campaign_name;
                return html`
                <style>
                :host::part(parent-name-cell) {
                    color: var(--core-color-core-dark-100, #3B3E3F);
                }
                :host::part(margin-left-20) {
                    margin-left: 20px;
                }
                :host::part(margin-left-40) {
                    margin-left: 40px;
                }
                :host::part(wrapText) {
                    display: flex;
                    flex-wrap: wrap;
                    white-space: normal;
                    line-height: 20px;
                    max-height: 40px;
                    overflow: hidden;
                    word-break: break-all;
                }
                .expand-wrapper.is-clamped {
                    max-width: 100% !important;
                }
                </style>
                <td part="table-body-cell parent-name-cell"><span part="wrapText ${value.marginClass ? value.marginClass : ""}"">${campaignName}</span></td>`
            }
        },
    ];

    campaignRightColumns = [
        {
            label: 'Actions',
            key: 'actions',
            passthrough: true,
            template: (value, index) => {            
                //const condition = !value.delivered_campaigns && value.campaign_name;
                let condition = false; // temporary as mapping is not in use
                return condition ? html`
                    <style>
                    :host::part(table-body) {
                        transform-style: flat;
                    }
                    </style>
                    <td part="table-body-cell"><button class="button is-outlined" @click=${()=>this.handleUnmapped(value)}>Unmap</button></td>`
                    : html`<td part="table-body-cell"/>`
            }
        }
    ];

    render() {
        return (
            <>
                <OmniStyleComponent>
                    <div className="platform-campaign-container">
                        <div className="platform-campaign-right-container">
                            <div className="platform-title-container">
                                <p className="platform-title">Platform campaigns</p>
                                <p className="platform-description">Choose platform campaigns that you would like to map to available campaigns</p>
                            </div>
                            <div className="platform-campaign-table-container">
                                <OmniToolbarComponent slot="header" className='platform-table-toolbar'>

                                    <div slot="end" className="platform-toolbar-menu">
                                        <button className="button is-outlined" disabled={this.state.enableMapToPlacement} onClick={this.handleMultipleMapping}>Map all selected</button>
                                        <div className="toolbar-icon-group">
                                            <div className="toolbar-divider" />
                                            <button className="button is-text is-shadowless">
                                                <OmniIconComponent className='is-size-4' icon-id="omni:interactive:importExport" />
                                            </button>

                                            <OmniSearchComponent
                                                ph="Search"
                                                onSearchUpdate={(event)=>this.updateSearch(event, 'platformCampaign')}
                                            />
                                            <div className="toolbar-divider" />
                                            <PlatformFilterComponent onApplyFilter={this.applyFilter.bind(this, 'platform')} />
                                        </div>
                                    </div>
                                </OmniToolbarComponent>
                                {this.state.isPlatformTableLoading 
                                ? Utils.displayTableSkeleton()
                                : this.state.platformTableData.length
                                ? <OmniTableStickyComponent
                                    keyFn={(row) => row}
                                    expandAllOnLoad={true}
                                    id="platform-campaign-table"
                                    data={this.state.platformTableData}
                                    sort={this.state.sort['platformSort']}
                                    leftColumns={this.platformLeftColumns}
                                    rightColumns={this.platformRightColumns}
                                    key={this.state.platformTableData.length}
                                    onSortUpdate={(event)=>this.updateSortColumn(event,'platform')}
                                />
                            : <NoDataComponent
                            heading={"No Data Found"}
                            message={"No Platform Campaign found!"}
                            />}
                            </div>
                        </div>
                        <div className="platform-campaign-left-container">
                            <div className="platform-title-container">
                                <p className="platform-title">Available campaigns</p>
                                <p className="platform-description">This table combines all available campaing and the mapped platform campaigns</p>
                            </div>
                            <div className="campaign-table-container">
                                <OmniToolbarComponent slot="header" className='platform-table-toolbar'>

                                    <div slot="end" className="platform-toolbar-menu">
                                        <div className="toolbar-icon-group">
                                            <button className="button is-text is-shadowless">
                                                <OmniIconComponent className='is-size-4' icon-id="omni:interactive:importExport" />
                                            </button>
                                            <OmniSearchComponent
                                                ph="Search"
                                                onSearchUpdate={(event)=>this.updateSearch(event, 'campaign')}
                                            />
                                            <div className="toolbar-divider" />
                                            <CampaignFilterComponent onApplyFilter={this.applyFilter.bind(this, 'campaing')} />
                                        </div>
                                    </div>
                                </OmniToolbarComponent>
                                {this.state.isCampaignTableDataLoading 
                                ?  Utils.displayTableSkeleton()
                                : this.state.campaignTableData.length
                                ? <OmniTableStickyComponent
                                    keyFn={(row) => row}
                                    expandAllOnLoad={true}
                                    id="campaign-table"
                                    data={this.state.campaignTableData}
                                    sort={this.state.sort['campaignSort']}
                                    leftColumns={this.campaignLeftColumns}
                                    rightColumns={this.campaignRightColumns}
                                    key={this.state.campaignTableData.length}
                                    onSortUpdate={(event)=>this.updateSortColumn(event,'campaign')}
                                /> 
                                : <NoDataComponent
                                heading={"No Data Found"}
                                message={"No Placements found!"}
                                />}
                            </div>
                        </div>
                    </div>
                    <div className="platform-campaign-actionButtons">
                        <button
                            onClick={this.handleSaveButton}
                            className='save button is-large'
                        >
                            <span className="close-text">Close</span>
                        </button>
                    </div>
                </OmniStyleComponent>
                <PlatformCampaignDialogComponent 
                closeModel={this.closeModel}
                isModelOpen={this.state.isModelOpen}
                selectedData={this.modelMappingData}
                dropdownOptions={this.modelDropdownOptions}
                setSpinnerCount={this.props.setSpinnerCount} 
                fetchCampaignTableData={this.fetchCampaignTableData}
                fetchPlatformDeliveredData={this.fetchPlatformDeliveredData} 
                setEnableMapToPlacement={(value) => this.setState({ enableMapToPlacement: value })}
                />
               
            </>
        )
    }
};